const schemaOrgUrl = 'https://schema.org'

export const schemaOrgUrls = {
  url: schemaOrgUrl,
  newCondition: `${schemaOrgUrl}/NewCondition`,
  inStock: `${schemaOrgUrl}/InStock`,
  outOfStock: `${schemaOrgUrl}/OutOfStock`,
}
